import React from 'react';

import { lineAmount, money } from './changeRequestFormat';

const DECREASE = 'decrease';

/**
 * How a request moves the line: the amount before, the amount after, and the change
 * itself. The two amounts read as the table's From and To cells do. A decrease reads
 * as a reduction in brackets; a change that moved no amount says so rather than
 * showing a zero.
 */
export default function ChangeAmountSummary({ row }) {
    const total = Number(row.total_amount ?? 0);
    const decrease = row.action_type === DECREASE;

    let label = $t('Total requested');
    let value = money(total);

    if (Math.round(total) === 0) {
        value = $t('No change');
    } else if (decrease) {
        label = $t('Total reduction');
        value = money(-total);
    }

    return (
        <div className="bc-amt-row">
            <div>
                <div className="bc-amt__label">{$t('Original')}</div>
                <div className="bc-amt__value">{lineAmount(row, row.original_amount)}</div>
            </div>
            <div className="bc-amt__arrow" aria-hidden="true">
                &rarr;
            </div>
            <div>
                <div className="bc-amt__label">{$t('New amount')}</div>
                <div className="bc-amt__value">{lineAmount(row, row.new_amount)}</div>
            </div>
            <div className="tw-grow" />
            <div className="tw-text-end">
                <div className="bc-amt__label">{label}</div>
                <div className="bc-amt__value bc-amt__value--blue">{value}</div>
            </div>
        </div>
    );
}
